import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: '350px !important'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(0, 2),
    width: '100%',
    [theme.breakpoints.up(390)]: {
      width: 370,
      padding: 0
    }
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  },
  select: {
    width: '60%',
    '& svg': {
      color: theme.palette.secondary.main
    },

    '& > div': {
      borderColor: theme.palette.primary.main,
      borderRadius: 0,
      boxShadow: '0px 4px 4px rgba(6, 0, 173, 0.15)'
    }
  },
  textField: {
    '& input': {
      height: 5
    }
  },
  button: {
    alignSelf: 'center',
    width: 220,
    height: 37,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  inscriptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '90%',
    alignItems: 'center'
  }
}))
